// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { OptionPositionItem } from '../../cache/OptionMaster/OptionPositionItem';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { PositionsPanel } from '../PositionsPanel';
import { DataCache } from '@shared/commons/DataCache';
export class OptionPositionsPanel extends PositionsPanel {
    constructor() {
        super();
        this.isFiltered = true;
        this.Name = 'OptionPositionsPanel';
        this.headerLocaleKey = 'panel.optionPositions';
        this.AddPositionEvent = this.AddPositionEvent.bind(this);
        this.RemovePositionEvent = this.RemovePositionEvent.bind(this);
        this.populateItemsDirect = this.populateItemsDirect.bind(this);
        this.onAccountChanged = this.onAccountChanged.bind(this);
    }
    oninit() {
        super.oninit();
        void super.set('isRelativeStyle', true);
        void super.set('isAllowPadding', false);
        super.observe('visible', this.onVisibleChanged);
    }
    getType() {
        return PanelNames.OptionPositionsPanel;
    }
    populateItemsDirect() {
        const quickTable = this.getQuickTable();
        quickTable.ClearAll();
    }
    TickAsync() {
        super.TickAsync();
        const isVisible = this.get('visible');
        if (!isVisible) {
            return;
        }
        this.getQuickTable().needRedrawBackground = true;
    }
    createPositionItem(position) {
        return new OptionPositionItem(this._optionTrader, position, SessionSettings);
    }
    DCEventsSubscribe() {
        if (isNullOrUndefined(this._optionTrader)) {
            return;
        }
        this._optionTrader.subscribeOnChangeAccountForPaperPositions(this.onAccountChanged);
        this._optionTrader.subscribeOnRepopulate(this.populateItemsDirect);
        this._optionTrader.subscribeOnAddPosition(this.AddPositionEvent);
        this._optionTrader.subscribeOnRemovePosition(this.RemovePositionEvent);
        DataCache.OnUpdatePosition.Subscribe(this.UpdatePositionEvent, this);
    }
    DCEventsUnSubscribe() {
        if (isNullOrUndefined(this._optionTrader)) {
            return;
        }
        this._optionTrader.unsubscribeOnChangeAccountForPaperPositions(this.onAccountChanged);
        this._optionTrader.unsubscribeOnRepopulate(this.populateItemsDirect);
        this._optionTrader.unsubscribeOnAddPosition(this.AddPositionEvent);
        this._optionTrader.unsubscribeOnRemovePosition(this.RemovePositionEvent);
        DataCache.OnUpdatePosition.UnSubscribe(this.UpdatePositionEvent, this);
    }
    callThemeChange() {
        this.themeChange();
    }
    callCallback(properties) {
        this.callBack(properties);
    }
    setOptionTrader(optionTrader) {
        this._optionTrader = optionTrader;
        this.DCEventsSubscribe();
    }
    onVisibleChanged() {
        this.layoutTable();
    }
    onAccountChanged() {
        var _a, _b;
        const qt = this.getQuickTable();
        const acctNumber = (_b = (_a = this._optionTrader) === null || _a === void 0 ? void 0 : _a.account) === null || _b === void 0 ? void 0 : _b.AcctNumber;
        if (qt != null && acctNumber != null) {
            qt.filterByAccountNumber(acctNumber);
        }
    }
}
